import MainLayout from '../layouts/main';
import AboutUs from './about-us';

function AboutUsPage() {
  return (
    <MainLayout loginRequired={false} consultPackageRequired={false} packageRequired={false}>
      <AboutUs/>
    </MainLayout>
  );
}

export default AboutUsPage;
